import React from 'react';
import { IModuleSelectorModal } from './interfaces';
import { Box, Button, Card, Chip, Container, Divider, Fade, Modal, Paper, Stack, Typography, useTheme } from '@mui/material';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import LanguageIcon from '@mui/icons-material/Language';
import CampaignIcon from '@mui/icons-material/Campaign';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import SpeedIcon from '@mui/icons-material/Speed';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ReceiptIcon from '@mui/icons-material/Receipt';

export const ModuleSelectorModal: React.FC<IModuleSelectorModal> = ({ show, onClose }): JSX.Element => {
  const theme = useTheme();
  const maxWidth = 345;

  return <Modal open={show} onClose={onClose}>
    <Fade in={show}>
      <Container maxWidth='lg' sx={{
        paddingTop: 5
      }}>
        <Paper elevation={3} sx={{
            background: theme.palette.grey[200]
        }}>
          <Box sx={{
            paddingTop: 3,
            paddingLeft: 3,
            paddingRight: 3,
            paddingBottom: 2,
            background: theme.palette.background.paper,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
          }}>
            <Typography variant='h4' component='h2' sx={{
              marginBottom: 1
            }}>
              Selecteer module
            </Typography>
            <Typography variant='body2' component='p' color={theme.palette.text.secondary}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </Typography>
          </Box>

          <Stack direction='row' gap={2} flexWrap="wrap" justifyContent='center' sx={{
            paddingTop: 2,
            paddingLeft: 2,
            paddingRight: 2,
            paddingBottom: 3
          }}>
            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <SpeedIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Dashboard
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <LanguageIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Website
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <SupervisedUserCircleIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Leden
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <CampaignIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Communicatie
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <CalendarMonthIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Inzetrooster
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <EmojiEventsIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Competities
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <CalendarMonthIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Activiteiten
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <StorefrontIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Marktplaats
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <InsertChartIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Inzicht
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <SettingsApplicationsIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Instellingen
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>

            <Card variant="outlined" sx={{ maxWidth }}>
              <Box sx={{ p: 2 }}>
                <Stack direction='row'>
                  <ReceiptIcon fontSize='large' sx={{
                    marginRight: 1
                  }} />
                  <Typography gutterBottom variant="h5" component="div">
                    Facturering
                  </Typography>
                </Stack>
                <Typography color="text.secondary" variant="body2">
                  Pinstriped cornflower blue cotton blouse takes you on a walk to the park or
                  just down the hall.
                </Typography>
                <Button variant='outlined' sx={{
                  marginTop: 1
                }}>Open</Button>
              </Box>
            </Card>
          </Stack>
        </Paper>
      </Container>
    </Fade>
  </Modal>
}